import { types, actions } from './requests'
export const SWITCHJOB_TYPES = {
    ...types('SWITCHJOB'),
}
export const SWITCHJOB_ACTIONS = {
    ...actions('SWITCHJOB'),
}
